import { useRouteNamespaces } from '@aikoa/i18n/react'
import { Stack } from 'expo-router'
import { useEffect } from 'react'
import { View } from 'react-native'
import AppHeader from '~/components/AppHeader'
import { useAppView } from '~/components/layout/AppViewContext'
import { useUserIsAdmin } from '~/data/user/useUserIsAdmin'
import { getStackHeaderOptions } from '~/lib/headerConfig'
import { cn } from '~/lib/utils'

export default function AppLayout() {
  useRouteNamespaces('(authenticated)')

  const isAdmin = useUserIsAdmin()
  const { setBackgroundTheme } = useAppView()

  useEffect(() => {
    setBackgroundTheme(0)
  }, [setBackgroundTheme])

  return (
    <View className={cn('my-2 flex-1')}>
      <AppHeader />
      <Stack screenOptions={getStackHeaderOptions()}>
        <Stack.Screen name="index" />
        <Stack.Protected guard={isAdmin}>
          <Stack.Screen name="admin" />
        </Stack.Protected>
      </Stack>
    </View>
  )
}
